// Notes Edit Actions
export const FETCH_STRATEGIC_CAPS_NOTES_EDIT_REQUEST = 'FETCH_STRATEGIC_CAPS_NOTES_EDIT_REQUEST';
export const FETCH_STRATEGIC_CAPS_NOTES_EDIT_SUCCESS = 'FETCH_STRATEGIC_CAPS_NOTES_EDIT_SUCCESS';
export const FETCH_STRATEGIC_CAPS_NOTES_EDIT_FAILURE = 'FETCH_STRATEGIC_CAPS_NOTES_EDIT_FAILURE';

// Notes Save Actions
export const FETCH_STRATEGIC_CAPS_NOTES_SAVE_REQUEST = 'FETCH_STRATEGIC_CAPS_NOTES_SAVE_REQUEST';
export const FETCH_STRATEGIC_CAPS_NOTES_SAVE_SUCCESS = 'FETCH_STRATEGIC_CAPS_NOTES_SAVE_SUCCESS';
export const FETCH_STRATEGIC_CAPS_NOTES_SAVE_FAILURE = 'FETCH_STRATEGIC_CAPS_NOTES_SAVE_FAILURE';

// Delete Report Actions
export const DELETE_STRATEGIC_CAPS_REPORT_REQUEST = 'DELETE_STRATEGIC_CAPS_REPORT_REQUEST';
export const DELETE_STRATEGIC_CAPS_REPORT_SUCCESS = 'DELETE_STRATEGIC_CAPS_REPORT_SUCCESS';
export const DELETE_STRATEGIC_CAPS_REPORT_FAILURE = 'DELETE_STRATEGIC_CAPS_REPORT_FAILURE';

// Export Report Actions
export const EXPORT_STRATEGIC_CAPS_REPORT_REQUEST = 'EXPORT_STRATEGIC_CAPS_REPORT_REQUEST';
export const EXPORT_STRATEGIC_CAPS_REPORT_SUCCESS = 'EXPORT_STRATEGIC_CAPS_REPORT_SUCCESS';
export const EXPORT_STRATEGIC_CAPS_REPORT_FAILURE = 'EXPORT_STRATEGIC_CAPS_REPORT_FAILURE';

// Get BlockPlanningCapacityVsDemandTableReport Actions
export const GET_STRATEGIC_CAPS_VS_DEMAND_REQUEST = 'GET_STRATEGIC_CAPS_VS_DEMAND_REQUEST';
export const GET_STRATEGIC_CAPS_VS_DEMAND_SUCCESS = 'GET_STRATEGIC_CAPS_VS_DEMAND_SUCCESS';
export const GET_STRATEGIC_CAPS_VS_DEMAND_FAILURE = 'GET_STRATEGIC_CAPS_VS_DEMAND_FAILURE';

// Reports Tab - GetAllReportsWithPagination
export const FETCH_STRATEGIC_CAPS_REPORTS_REQUEST = 'FETCH_STRATEGIC_CAPS_REPORTS_REQUEST';
export const FETCH_STRATEGIC_CAPS_REPORTS_SUCCESS = 'FETCH_STRATEGIC_CAPS_REPORTS_SUCCESS';
export const FETCH_STRATEGIC_CAPS_REPORTS_FAILURE = 'FETCH_STRATEGIC_CAPS_REPORTS_FAILURE';

// Dropdown Actions
export const FETCH_STRATEGIC_CAPS_DROPDOWN_REQUEST = 'FETCH_STRATEGIC_CAPS_DROPDOWN_REQUEST';
export const FETCH_STRATEGIC_CAPS_DROPDOWN_SUCCESS = 'FETCH_STRATEGIC_CAPS_DROPDOWN_SUCCESS';
export const FETCH_STRATEGIC_CAPS_DROPDOWN_FAILURE = 'FETCH_STRATEGIC_CAPS_DROPDOWN_FAILURE';

// Dropdown GetWeekQuarterByMonthYear
export const FETCH_WEEK_QUARTER_CAPS_DROPDOWN_REQUEST = 'FETCH_WEEK_QUARTER_CAPS_DROPDOWN_REQUEST';
export const FETCH_WEEK_QUARTER_CAPS_DROPDOWN_SUCCESS = 'FETCH_WEEK_QUARTER_CAPS_DROPDOWN_SUCCESS';
export const FETCH_WEEK_QUARTER_CAPS_DROPDOWN_FAILURE = 'FETCH_WEEK_QUARTER_CAPS_DROPDOWN_FAILURE';

// DD filtermodel Actions
export const FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_REQUEST = 'FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_REQUEST';
export const FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_SUCCESS = 'FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_SUCCESS';
export const FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_FAILURE = 'FETCH_FILTER_STRATEGIC_CAPS_DROPDOWN_FAILURE';

// wRVU Surplus Worklist View Table Actions
export const FETCH_WRVU_SURPLUS_WORKLIST_REQUEST = 'FETCH_WRVU_SURPLUS_WORKLIST_REQUEST';
export const FETCH_WRVU_SURPLUS_WORKLIST_SUCCESS = 'FETCH_WRVU_SURPLUS_WORKLIST_SUCCESS';
export const FETCH_WRVU_SURPLUS_WORKLIST_FAILURE = 'FETCH_WRVU_SURPLUS_WORKLIST_FAILURE';

// wRVU Surplus(Gap) View Table Actions
export const FETCH_WRVU_SURPLUS_REQUEST = 'FETCH_WRVU_SURPLUS_REQUEST';
export const FETCH_WRVU_SURPLUS_SUCCESS = 'FETCH_WRVU_SURPLUS_SUCCESS';
export const FETCH_WRVU_SURPLUS_FAILURE = 'FETCH_WRVU_SURPLUS_FAILURE';

// FTE Surplus (Gap) View Table Actions
export const FETCH_FTE_SURPLUS_REQUEST = 'FETCH_FTE_SURPLUS_REQUEST';
export const FETCH_FTE_SURPLUS_SUCCESS = 'FETCH_FTE_SURPLUS_SUCCESS';
export const FETCH_FTE_SURPLUS_FAILURE = 'FETCH_FTE_SURPLUS_FAILURE';

// Legend Actions
export const FETCH_LEGEND_REQUEST = 'FETCH_LEGEND_REQUEST';
export const FETCH_LEGEND_SUCCESS = 'FETCH_LEGEND_SUCCESS';
export const FETCH_LEGEND_FAILURE = 'FETCH_LEGEND_FAILURE';

 // Draft Actions
export const DRAFT_STRATEGIC_CAPS_REQUEST = 'DRAFT_STRATEGIC_CAPS_REQUEST';
export const DRAFT_STRATEGIC_CAPS_SUCCESS = 'DRAFT_STRATEGIC_CAPS_SUCCESS';
export const DRAFT_STRATEGIC_CAPS_FAILURE = 'DRAFT_STRATEGIC_CAPS_FAILURE';

// Publish Actions
export const PUBLISH_STRATEGIC_CAPS_REQUEST = 'PUBLISH_STRATEGIC_CAPS_REQUEST';
export const PUBLISH_STRATEGIC_CAPS_SUCCESS = 'PUBLISH_STRATEGIC_CAPS_SUCCESS';
export const PUBLISH_STRATEGIC_CAPS_FAILURE = 'PUBLISH_STRATEGIC_CAPS_FAILURE';

// get Worklist by RPCEID dropdown Actions
export const GET_WORKLIST_BY_RPCEID_REQUEST = 'GET_WORKLIST_BY_RPCEID_REQUEST';
export const GET_WORKLIST_BY_RPCEID_SUCCESS = 'GET_WORKLIST_BY_RPCEID_SUCCESS';
export const GET_WORKLIST_BY_RPCEID_FAILURE = 'GET_WORKLIST_BY_RPCEID_FAILURE';

// filter Apply Actions
export const FILTER_STRATEGIC_CAPS_APPLY_REQUEST = 'FILTER_STRATEGIC_CAPS_APPLY_REQUEST';
export const FILTER_STRATEGIC_CAPS_APPLY_SUCCESS = 'FILTER_STRATEGIC_CAPS_APPLY_SUCCESS';
export const FILTER_STRATEGIC_CAPS_APPLY_FAILURE = 'FILTER_STRATEGIC_CAPS_APPLY_FAILURE';

// filter get by id Actions
export const FETCH_CAPS_DEMAND_FILTER_BY_ID_REQUEST = "FETCH_CAPS_DEMAND_FILTER_BY_ID_REQUEST";
export const FETCH_CAPS_DEMAND_FILTER_BY_ID_SUCCESS = "FETCH_CAPS_DEMAND_FILTER_BY_ID_SUCCESS";
export const FETCH_CAPS_DEMAND_FILTER_BY_ID_FAILURE = "FETCH_CAPS_DEMAND_FILTER_BY_ID_FAILURE";


// Common update reducer
export const UPDATE_STRATEGIC_CAPS_REDUCER = 'UPDATE_STRATEGIC_CAPS_REDUCER';


